const crops = {
    crops: {
        "1": "Sandía",
        "2": "Calabaza de verano",
        "3": "Calabacín",
        "4": "Caña de azúcar",
        "5": "Pepino encurtido",
        "6": "Manzanas",
        "7": "Apio",
        "8": "Albaricoque",
        "9": "Apio verde de otoño",
        "10": "Cebollino - 1er año",
        "11": "Cebollino - 2do año",
        "12": "Zanahorias lavadas",
        "13": "Batatas",
        "14": "Maíz (ensilaje 67% agua)",
        "15": "Melocotones",
        "16": "Patatas",
        "17": "Cebolleta",
        "18": "Ajo",
        "19": "Col rizada",
        "20": "Fresas",
        "21": "Remolacha",
        "22": "Brócoli",
        "23": "Coles de Bruselas",
        "24": "Apio - blanqueado de otoño",
        "25": "Remolacha azucarera",
        "26": "Zanahoria de invierno",
        "27": "Tomates",
        "28": "Cebolla de invierno",
        "29": "Uvas (mesa)",
        "30": "Lechuga - cabeza de verano",
        "31": "Perejil",
        "32": "Lechuga - de hoja de verano",
        "33": "Lechuga hoja de roble",
        "34": "Alcachofa de Jerusalén Topinambur",
        "35": "Ciruelas pasas",
        "36": "Melón",
        "37": "Palma aceitera",
        "38": "Lechuga",
        "39": "Kiwi",
        "40": "Repollo rojo",
        "41": "Peras",
        "42": "Banana",
        "43": "Endivia escarola - verano",
        "44": "Endivia escarola - baby",
        "45": "Endivia de hoja rizada",
        "46": "Repollo - almacenamiento común",
        "47": "Puerro de verano",
        "48": "Puerro otoño invierno",
        "49": "Fresa de fructificación perpetua",
        "50": "Papaya",
        "51": "Espinaca",
        "52": "Procesamiento de tomate",
        "53": "Calabaza",
        "54": "Achicoria",
        "55": "Repollo",
        "56": "Berenjena",
        "57": "Col de Primavera",
        "58": "Col de Saboya",
        "59": "Col de Saboya verde",
        "60": "Judía",
        "61": "Naranjas",
        "62": "Chalota roja",
        "63": "Melón",
        "64": "Tabaco (curado al aire caliente)",
        "65": "Tabaco (burley)",
        "66": "Café",
        "67": "Cebada (primavera)",
        "68": "Trigo 10% proteína",
        "69": "Trigo 12% proteína",
        "70": "Trigo 14% proteína",
        "71": "Maíz (grano)",
        "72": "Girasol",
        "73": "Arroz",
        "74": "Sorgo (grano)",
    },
};
export default crops;
